import React from 'react';
import {
  Card,
  CardContent,
  CardProps,
  Rating,
  Stack,
  Typography,
} from '@mui/material';

import moment from 'moment';
import { ISubTopicReview } from '../../../../store/SubTopicSlice';
import { isMobileScreen } from '../../../../helper';

const cardStyles: CardProps['style'] = {
  border: '1px solid #ededed',
  width: 'calc(100%)',
  borderRadius: '12px',
  marginBottom: '10px',
};

export interface IReviewSection {
  reviewList: ISubTopicReview[];
}

const ReviewSection: React.FC<IReviewSection> = ({ reviewList }) => {
  const isMobile = isMobileScreen();
  return (
    <div style={{ margin: '30px 40px' }}>
      <Typography variant="h5" fontWeight={600} style={{ margin: '10px' }}>
        Reviews
      </Typography>
      {reviewList.map((reviewItem) => (
        <Card key={reviewItem._id} elevation={0} style={cardStyles}>
          <CardContent style={{ padding: '16px' }}>
            <Stack direction="row" justifyContent="space-between">
              <Stack direction="row">
                <Rating value={reviewItem.rating} readOnly />
                <Typography
                  variant="subtitle2"
                  className="ellipsis-text"
                  fontWeight={600}
                  style={{ marginLeft: '15px', paddingTop: '2px' }}
                >
                  {reviewItem.reviewer || ''}
                </Typography>
              </Stack>
              {!isMobile && (
                <Typography color="secondary" variant="body2">
                  {moment(reviewItem.createdAt).format('DD MMM YYYY')}
                </Typography>
              )}
            </Stack>
            {isMobile && (
              <Typography
                color="secondary"
                variant="body2"
                style={{ padding: '5px 0 0 5px' }}
              >
                {moment(reviewItem.createdAt).format('DD MMM YYYY')}
              </Typography>
            )}

            <Typography variant="body2" style={{ margin: '10px 0 0 5px' }}>
              {reviewItem.review}
            </Typography>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default ReviewSection;
